// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1GU6j","footer":"Form_footer__1-ojb"};